import { assetQuery } from '../services/sanity';
export const shopQuery = `{
  _id,
  bannerText,
  carouselItems[] {
    _key,
    image ${assetQuery},
    productSlug,
    title
  }
}`;
//# sourceMappingURL=shop.js.map